module.exports = __webpack_public_path__ + "static/media/footer_background_sales.7f7ec2f3.png";